import React, { Component } from "react";
import "./css/tester.css";

export default class tester extends Component {
  render() {
    return (
      <div className="test-main">
        <div className="test-scroll-contain">
          <div className="test-scroller"></div>
        </div>
      </div>
    );
  }
}
